import Efirma from 'Components/icons/EFirma';
import Rfc from 'Components/icons/Rfc';

export default [
  {
    label: 'Dg.access.rfc',
    value: 'rfc',
    testID: 'RFC',
    description: 'Dg.access.rfc.description',
    imageUrl: <Rfc />,
  },
  {
    label: 'Dg.access.efirma',
    value: 'efirma',
    testID: 'Efirma',
    description: 'Dg.access.efirma.description',
    imageUrl: <Efirma />,
  },
];
